import React, { useRef, useState } from "react";
import WebView from "react-native-webview";
import ActivityIndicator from "../components/ActivityIndicator";
import Screen from "../components/Screen";

function InfoWebScreen({ route }) {
  const finalUrl = route.params;
  const [loading, setLoading] = useState(false);

  const webView = useRef();
  // console.log("oit", finalUrl);
  return (
    <Screen>
      <WebView
        //   style={styles.container}
        renderLoading={() => <ActivityIndicator />}
        source={{ uri: finalUrl }}
        ref={webView}
        cacheEnabled={false}
        onLoadStart={() => setLoading(true)}
        onLoad={() => setLoading(false)}
      />
      {/* <ActivityIndicator visible={loading} /> */}
    </Screen>
  );
}

export default InfoWebScreen;
